import React, {useEffect, useState} from 'react';
import {doc, getDoc} from 'firebase/firestore';
import {FaExternalLinkAlt} from 'react-icons/fa';
import {db} from '../utils/firebase';
import {useLang} from '../context/LanguageContext';
import {DEFAULT_OPEN_WEBSITE_BUTTON_ENABLED} from '../utils/openWebsiteButton';

const WEBSITE_HOST = 'latg.ro';
const WEBSITE_URL = `https://${WEBSITE_HOST}`;

// pe Android, un link intent:// poate scoate userul din browserul in-app (TikTok/Facebook)
// in browserul implicit; daca nu merge, browser_fallback_url deschide linkul normal.
// pe iOS nu exista metoda sigura, ramane link normal.
const buildHref = () => {
    const isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
    if (!isAndroid) return WEBSITE_URL;
    return `intent://${WEBSITE_HOST}#Intent;scheme=https;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(WEBSITE_URL)};end`;
};

const OpenWebsiteButton = () => {
    const {t} = useLang();
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const load = async () => {
            try {
                const snap = await getDoc(doc(db, 'appSettings', 'openWebsiteButton'));
                setEnabled(snap.exists() && typeof snap.data().enabled === 'boolean'
                    ? snap.data().enabled
                    : DEFAULT_OPEN_WEBSITE_BUTTON_ENABLED);
            } catch (err) {
                setEnabled(DEFAULT_OPEN_WEBSITE_BUTTON_ENABLED);
            }
        };
        load();
    }, []);

    if (!enabled) {
        return null;
    }

    return (
        <a
            href={buildHref()}
            className="max-w-[95vw] md:max-w-[800px] mx-auto my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center gap-2 p-2 text-[#e67e22] justify-center uppercase font-bold"
        >
            <FaExternalLinkAlt size={14}/>
            {t('txt.goToWebsite')}
        </a>
    );
};

export default OpenWebsiteButton;
